import React from "react";

const sliceData = <T extends {}>({ pageIndex, perPage }: { pageIndex: number; perPage: number }, data: T[]): T[] =>
  data.slice(pageIndex * perPage, (pageIndex + 1) * perPage);

export const usePagination = <T>(data: T[], dataPerPage: number = 50) => {
  const [pageIndex, setPageIndex] = React.useState(0);
  const [perPage, setPerPage] = React.useState(dataPerPage);
  const [maxPreloadedPage, setMaxPreloadedPage] = React.useState<number>(Math.floor(data.length / dataPerPage));

  React.useEffect(() => setPageIndex(0), [perPage]);

  const value = {
    maxPreloadedPage,
    pageIndex,
    perPage,
    setMaxPreloadedPage,
    setPageIndex,
    setPerPage,
  };
  const pagedData = sliceData({ pageIndex, perPage }, data) as T[];
  return { value, pagedData };
};
